import { all, fork } from 'redux-saga/effects'

import DashboardSaga from './DashboardSaga'

export default function* dashboardSagas() {
  yield all([fork(new DashboardSaga().supervise)])
}
